import { render } from "./WohnungStep10.vue?vue&type=template&id=4833b104&scoped=true"
import script from "./WohnungStep10.vue?vue&type=script&lang=js"
export * from "./WohnungStep10.vue?vue&type=script&lang=js"

import "./WohnungStep10.vue?vue&type=style&index=0&id=4833b104&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4833b104"]])

export default __exports__